import { useState, useEffect } from 'react';

function getValueFromStorage(key, initialValue) {
  const savedValue = JSON.parse(localStorage.getItem(key));
  if(savedValue) return savedValue;
  
  if(initialValue instanceof Function) return initialValue();
  return initialValue;
}

export default function useLocalStorage(key, initialValue) {
  const [value, setValue] = useState(() => getValueFromStorage(key, initialValue));

  useEffect(() => {
    //console.log("UseLocalStorage: key - ", key, " value - ", value)
    localStorage.setItem(key, JSON.stringify(value))
  }, [key,value]);

  return [value, setValue]
}